/// <reference path="../../../../typings/index.d.ts" />

module Meevo.RequireClockIn {
    export class RequireClockInController {

        closeContext: Function;
        context: RequireClockInContext;

        static $inject = [
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "$translate",
            "$mdDialog",
            "$window",
            "$rootScope"
        ];

        constructor(
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            $translate: angular.translate.ITranslateService,
            private $mdDialog: angular.material.IDialogService,
            private $window: angular.IWindowService,
            private $rootScope: angular.IRootScopeService
        ) {
            var modalHandler = () => { this.$mdDialog.hide(); };
            this.context = new RequireClockInContext(dataService, identityService, modalService, $translate, modalHandler, $window, $rootScope);
        }
    }

    angular.module("meevo")
        .controller("meevo.requireClockIn.RequireClockInController", RequireClockInController);
}

